module.exports = __webpack_public_path__ + "img/ImmerFotos.ff30f869.jpg";